import tables from './tables';
import utils from '../utils';

const getMappedAmazonBrands = async (token) => {
  try {
    const table = tables.brandStaging_amazon;
    const { data } = await utils.getFromMikMakFirebaseService(`get/${table}?orderBy=isMapped&equalTo=true`, token);

    return data.reduce((brands, brand) => {
      brands[brand.id_country] = brand;

      return brands;
    }, {});
  } catch (e) {
    throw `Error getting mapped Amazon brands: ${e}`;
  }
};

const getUnMappedAmazonBrands = async (token) => {
  try {
    const table = tables.brandStaging_amazon;
    const { data } = await utils.getFromMikMakFirebaseService(`get/${table}?orderBy=isMapped&equalTo=false`, token);
    const brands = data.reduce((brands, brand) => {
      brands[brand.id_country] = brand;

      return brands;
    }, {});

    return brands;
  } catch (e) {
    throw `Error getting unmapped Amazon brands: ${e}`;
  }
};

const getAllAmazonBrands = async (token) => {
  try {
    const table = tables.brandStaging_amazon;
    const { data } = await utils.getFromMikMakFirebaseService(`get/${table}?orderBy=isMapped`, token);
    const brands = data.reduce((brands, brand) => {
      brands[brand.id_country] = brand;

      return brands;
    }, {});

    return brands;
  } catch (e) {
    throw `Error getting all Amazon brands: ${e}`;
  }
};

const getAmazonEnrolledUser = async (id, token) => {
  try {
    const table = tables.amazonSalesInsightsEnrollments;
    const data = await utils.queryFirebaseServiceByKeyValue(table, 'mikmak_user_id', id, token);

    return data;
  } catch (e) {
    throw `Error getting Amazon user: ${e}`;
  }
};

export default {
  getAmazonEnrolledUser,
  getMappedAmazonBrands,
  getUnMappedAmazonBrands,
  getAllAmazonBrands,
};
